import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext } from 'react-hook-form';

import { required } from '../../../utils/form-default-errors';
import { Typography } from '../../../components';
import * as S from '../CreateResource.styles';

export const StepResourceType = () => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<S.FormPanel>
			<Typography tag="h2" weight="extrablack" center>
				Select a Type
			</Typography>
			<Typography tag="p" center>
				Select an option for the type of request you would like to make.
			</Typography>
			<div className="radio-wrapper">
				<div className={`radio-field${errors.type ? ' with-error' : ''}`}>
					<input
						className="radio-input"
						type="radio"
						id="appointment"
						value="appointment"
						{...register('type', {
							required: required('Type'),
						})}
					/>
					<FontAwesomeIcon icon={['fal', 'calendar']} size="4x" />
					<Typography tag="h5" weight="bold" center>
						Appointment
					</Typography>
					<Typography tag="p" variation="2" center>
						A resource to be scheduled at a specific time and place by the booking user.
					</Typography>
				</div>
				<div className={`radio-field${errors.type ? ' with-error' : ''}`}>
					<input
						className="radio-input"
						type="radio"
						id="event"
						value="event"
						{...register('type', {
							required: required('Type'),
						})}
					/>
					<FontAwesomeIcon icon={['fal', 'presentation']} size="4x" />
					<Typography tag="h5" weight="bold" center>
						Event
					</Typography>
					<Typography tag="p" variation="2" center>
						An event to be hosted at a specific time and place by your team.
					</Typography>
				</div>
				<div className={`radio-field${errors.type ? ' with-error' : ''}`}>
					<input
						className="radio-input"
						type="radio"
						id="information"
						value="information"
						{...register('type', {
							required: required('Request Type'),
						})}
					/>
					<FontAwesomeIcon icon={['fal', 'info-circle']} size="4x" />
					<Typography tag="h5" weight="bold" center>
						Information
					</Typography>
					<Typography tag="p" variation="2" center>
						An informational resource with files, links, and other helpful content.
					</Typography>
				</div>

				{!!errors.type && (
					<div className="error-wrapper">
						<Typography tag="p" variation="2">
							{errors.type.message}
						</Typography>
					</div>
				)}
			</div>
		</S.FormPanel>
	);
};
